import { render, staticRenderFns } from "./signUpPC.vue?vue&type=template&id=5ce97688&scoped=true"
import script from "./signUpPC.vue?vue&type=script&lang=js"
export * from "./signUpPC.vue?vue&type=script&lang=js"
import style0 from "./signUpPC.vue?vue&type=style&index=0&id=5ce97688&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce97688",
  null
  
)

export default component.exports